import { styled } from '@mui/material'
import { useMainLayoutContext } from '../MainLayout'

import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import AutoBreadCrumb from '../../../AutoBreadCrumb'

export interface IMainProps {
  children?: React.ReactNode,
}

const MainStyled = styled('main', { shouldForwardProp: (prop) => prop !== 'isSideBarOpen' && prop !== 'sideBarWidth' })<{
  isSideBarOpen: boolean,
  sideBarWidth: number,
}>(({ theme, sideBarWidth, isSideBarOpen }) => ({
  flexGrow: 1,
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${sideBarWidth}px`,
  ...(isSideBarOpen && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  }),
  overflow:'auto'
}));

export default function Main({ children }: IMainProps) {

  const { sideBarWidth, isSideBarOpen, navigationBarHeight, topRightComponent } = useMainLayoutContext()

  return (
    <MainStyled sideBarWidth={sideBarWidth} isSideBarOpen={isSideBarOpen}>
      {/* <Stack sx={{ height: '100%' }} pt={`${navigationBarHeight}px`}  maxWidth={t=>t.breakpoints.values.xl} margin={'0 auto'}> */}
      <Stack sx={{ height: '100%' }} pt={`${navigationBarHeight}px`} >
        <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} px={3}>
          {/* <AutoBreadCrumb/> */}
          {topRightComponent}
        </Stack>
        <Box sx={{ flex: 1, p:1.3, position:'relative' }}>
          {children}
        </Box>
      </Stack>
    </MainStyled>
  );
}
